import { css } from '@emotion/react';
import { type FC } from 'react';
import type { Theme } from '~/_shared/themes/theme.model';

export type SubTextHighlightProps = Readonly<{
  text: string;
  highlight: string;
  className?: string;
}>;

const highlightedPartStyle = (theme: Theme) => css({
  backgroundColor: theme.backgroundColors.quaternary,
  borderRadius: 2,
});

export const SubTextHighlightComponent: FC<SubTextHighlightProps> = ({ text, highlight, className }) => {
  if (!highlight) {
    return <span className={className}>{text}</span>;
  }

  const escaped = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // Using a capturing group so split includes the matched parts
  const parts = text.split(new RegExp(`(${escaped})`, 'gi'));

  return (
    <span className={className}>
      {parts.map((part, index) =>
        // Odd indices are the captured matches
        index % 2 === 1 ? (
          <span key={index} css={highlightedPartStyle}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </span>
  );
};
